module.exports = fox._r("images/fs_off.gif", __webpack_public_path__ + "images/fs_off.gif");


//////////////////
// WEBPACK FOOTER
// ./images/fs_off.gif
// module id = 1047
// module chunks = 4